import React from "react";
import StaticPage from "./StaticPage";

export default function About() {
  return (
    <StaticPage
      eyebrow="About"
      title="About SenseWise"
      testId="page-about"
    >
      <p>
        SenseWise is a sensory self-regulation companion built by
        <strong> Occuthera</strong>. It pairs a warm, feelings-first check-in with eight OT-grounded
        sensory boxes — giving students, therapists, and educators a shared, evidence-based vocabulary
        for what a nervous system needs right now.
      </p>

      <h2>Who we build for</h2>
      <ul>
        <li><strong>School-based occupational therapists</strong> managing full caseloads across
          multiple campuses.</li>
        <li><strong>Special education and general-education teachers</strong> who want a co-regulation
          tool that fits inside a classroom minute.</li>
        <li><strong>School district administrators</strong> looking for a clinical-grade,
          privacy-respecting tool that scales across sites.</li>
        <li><strong>Students, teens, and adults</strong> who benefit from a calm, age-neutral interface
          for identifying and acting on their own sensory needs.</li>
      </ul>

      <h2>Our principles</h2>
      <ul>
        <li><strong>OT-built.</strong> Every intervention is authored inside the Ayres SI &amp; Dunn
          frameworks.</li>
        <li><strong>Age-neutral.</strong> A student in second grade, a middle-schooler, and an adult
          all see the same interface — no cartoons, no infantilizing language.</li>
        <li><strong>Silent, respectful logging.</strong> Selections inform an OT&apos;s clinical notes;
          they are not gamified, ranked, or displayed back to the student as scores.</li>
        <li><strong>Privacy first.</strong> No advertising, no third-party trackers, no data sold —
          ever. See our <a href="/privacy">Privacy Policy</a>.</li>
      </ul>

      <h2>School district partnerships</h2>
      <p>SenseWise is designed to be deployed across a district under a written Data Processing
        Addendum (DPA) or California Student Data Privacy Agreement (CSDPA). To request a district
        pilot or a signed DPA, email <a href="mailto:Hello@occuthera.com">Hello@occuthera.com</a>.</p>

      <h2>Contact</h2>
      <p>
        Occuthera<br />
        <a href="mailto:Hello@occuthera.com">Hello@occuthera.com</a><br />
        <a href="https://occuthera.com" target="_blank" rel="noreferrer">occuthera.com</a>
      </p>
    </StaticPage>
  );
}
